import { Bar, mixins } from "vue-chartjs";
import isEqual from "lodash.isequal";
const { reactiveProp } = mixins;
export default {
  extends: Bar,
  mixins: [reactiveProp],
  props: {
    options: {
      type: Object,
      default() {
        return {};
      }
    },
    chartData: {
      type: Object,
      required: false
    },
    headline: {
      type: String,
      default: () => "Kennzahlen"
    }
  },
  mounted() {
    this.updateChart();
  },
  watch: {
    chartData(value, oldValue) {
      if (value && (!oldValue || !isEqual(value, oldValue))) {
        this.updateChart(value);
      }
    }
  },
  data() {
    return {
      legendItems: {}
    };
  },
  methods: {
    updateChart(value) {
      if (!value) {
        return;
      }
      this.renderChart(
        value,
        Object.assign(
          {
            title: {
              display: true,
              text: this.headline
            },
            legend: {
              onClick(e, legendItem) {
                console.log(legendItem);
                let ci = this.chart;
                for (const li of ci.legend.legendItems) {
                  if (li.text == legendItem.text) {
                    const index = li.datasetIndex;
                    let meta = ci.getDatasetMeta(index);
                    meta.hidden =
                      meta.hidden === null
                        ? !ci.data.datasets[index].hidden
                        : null;
                  }
                }
                ci.update();
              },
              labels: {}
            },
            tooltips: {
              callbacks: {
                title([tooltipItem], data) {
                  if (tooltipItem.label.includes(" / ")) {
                    const parts = tooltipItem.label.split(" / ");
                    const stack = data.datasets[tooltipItem.datasetIndex].stack;
                    return parts[parseInt(stack)];
                  }
                  return tooltipItem.label;
                }
              }
            },
            responsive: true,
            maintainAspectRatio: false,
            interaction: {
              intersect: false
            },
            scales: {
              xAxes: [
                {
                  stacked: true
                  /*ticks: {
                                        callback: function (label) {
                                            const parts = label.split(" / ")
                                            if (parts.length == 1) {
                                                return parts
                                            }
                                            return [parts[0], "", parts[1]];
                                        },
                                    }*/
                }
              ],
              yAxes: [
                {
                  stacked: true
                }
              ]
            }
          },
          this.options
        )
      );
    }
  }
};
